module.exports = __webpack_public_path__ + "static/media/right-arrow.7fc6207f.svg";